"use client";

import Link from "next/link";
import { useCart } from "@/app/providers";

export default function NavBar({ activePage }) {
  const { itemCount } = useCart();

  return (
    <header className="navbar">
      <div className="navbar__inner">
        <Link href="/" className="navbar__brand">
          <img
            src="/dreamy_logo.svg"
            alt="DreamyMed"
            className="navbar__logo"
          />
        </Link>

        <nav className="navbar__nav">
          <Link
            href="/menu"
            className={`navbar__nav-link${activePage === "menu" ? " navbar__nav-link--active" : ""}`}
          >
            Menu
          </Link>
          <Link
            href="/cart"
            className={`navbar__nav-link navbar__cart-link${activePage === "cart" ? " navbar__nav-link--active" : ""}`}
          >
            Cart
            {itemCount > 0 && (
              <span className="navbar__cart-badge">
                {itemCount > 9 ? "9+" : itemCount}
              </span>
            )}
          </Link>
        </nav>
      </div>
    </header>
  );
}
